module.exports = __webpack_public_path__ + "media/auto_history/zmiana_wlasciciela-0838b341.png";